export const REACT_APP_EVERSOURCE_URL = process.env.REACT_APP_EVERSOURCE_URL;

export const REACT_APP_APP_INSIGHTS_KEY =
  process.env.REACT_APP_APP_INSIGHTS_KEY;

export const REACT_APP_ALERTS_URL = process.env.REACT_APP_ALERTS_URL;

export const REACT_APP_LD_KEY = process.env.REACT_APP_LD_KEY;

export const FF_OPT_OUT = "es.ms.1clickpaperless.paperless-opt-out"